import React from 'react';
import { SophieChat } from '../../components/sophie/SophieChat';

const SophiePage: React.FC = () => {
  return (
    <div className="h-full w-full">
        <SophieChat />
    </div>
  );
};

export default SophiePage;
